<div class="wrapper" [class.custom-scroll]="isDrsite">
  <!-- <span class="text-default">Best Practice <span class="small">1 of 12</span> </span> -->
  <div class="container px-0">
    <!--<div class="pb-2">
      <h5 class="title fw-bold text-center mb-2 mt-2" style="font-size:20px"> {{'RegistrationPage.title' | translate}}</h5>
    </div>-->
    <!--<h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>-->
    <!--<h5 *ngIf="flowType !=''" class="title fw-bold text-center mb-4" style="font-size:21px">-->
    <!--{{(flowType == 'appointment' ? 'existingPatientLogin.flowtypeAppointment': (flowType == 'payment' ? 'existingPatientLogin.flowtypePayment' : 'existingPatientLogin.flowtypeCheckin')) | translate }}-->
    <!--{{(flowType == 'appointment' ? 'existingPatientLogin.flowtypeAppointment': 'existingPatientLogin.flowtypePayment') | translate }}
    </h5>-->
    <h5 *ngIf="flowType != ''" class="title fw-bold text-center mb-4" style="font-size:21px"
      [ngClass]="{'mt-5': isForLabOrder}">
      {{
      flowType == 'appointment'
      ? ('existingPatientLogin.flowtypeAppointment' | translate) + ' ' + (providername || 'Unknown Provider')
      : flowType == 'laborder'
      ? 'Provide following details to print lab/imaging order'
      : ('existingPatientLogin.flowtypePayment' | translate)
      }}
    </h5>


    <h5 *ngIf="flowType ==''" class="title fw-bold text-center mb-4" style="font-size:21px"
      [ngClass]="{'mt-5': IslandeFromQRCode}">
      {{'existingPatientLogin.flowtypeCheckin'| translate}}
    </h5>

    <div class="px-2 pb-3">
      <!-- <div class="container p-2 text-right" >
      !-- <a class="btn btn-outline-primary" type="button" (click)="RegistorNewPatient()">New Patient</a> -->
      <!-- <p class="mb-0">(4 of 7)</p> --

      </div> -->
      <form [formGroup]="loginForm">
        <div class="form-row">
          <div class="col-md-12" *ngIf="flowType != 'laborder'">
            <div class="form-group ">
              <div class="mb-2 border-bottom">
                <label class="fw-bold" style="font-size:20px;">
                  {{'existingPatientLogin.existingPatientLogin_firstName'|translate}}<span class="text-danger">*</span>
                </label>
                <input style="font-size:20px !important;" type="text" class="form-control text-capitalize border-0"
                  placeholder="{{'existingPatientLogin.existingPatientLogin_firstNameplaceholder'| translate}}"
                  formControlName="firstname" [ngStyle]="{'border' : getloginForm.firstname.invalid
                && getloginForm.firstname.touched && getloginForm.firstname.errors!.required ? '1px solid red' : ''}"
                  maxlength="35" (input)="ValidatePersonalInfo($event,'firstname')" />
              </div>
              <div class="mb-2">
                <span *ngIf="getloginForm.firstname.invalid && getloginForm.firstname.touched
               && getloginForm.firstname.errors!.required" class="err">
                  {{'existingPatientLogin.existingPatientLogin_firstnamerequired'|translate}}
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-12" *ngIf="flowType != 'laborder'">
            <div class="form-group ">
              <div class="mb-2 border-bottom">
                <label class="fw-bold" style="font-size:20px;">
                  {{
                  'existingPatientLogin.existingPatientLogin_lastName'|
                  translate
                  }}<span class="text-danger">*</span>
                </label>

                <input style="font-size:20px !important;" type="text"
                  class="form-control text-capitalize border-0 ltr-component"
                  placeholder="{{'existingPatientLogin.existingPatientLogin_lastNameplaceholder'| translate}}"
                  formControlName="lastname" [ngStyle]="{'border' : getloginForm.lastname.invalid
                && getloginForm.lastname.touched && getloginForm.lastname.errors!.required ? '1px solid red' : ''}"
                  maxlength="35" (input)="ValidatePersonalInfo($event,'lastname')" />

              </div>
              <div class="mb-2">
                <span *ngIf="getloginForm.lastname.invalid && getloginForm.lastname.touched
                && getloginForm.lastname.errors!.required" class="err">
                  {{'existingPatientLogin.existingPatientLogin_lastnamerequired'|translate}}
                </span>
              </div>
            </div>
          </div>
          <!--<div class="col-md-12">
            <div class="form-group mb-4">
              <label style="font-size:20px;" class="fw-bold">{{'verifypatient.dateofbirth' | translate}}<span class="text-danger">*</span>
              </label>
              <div class="form-group form-floating">
                <div class="position-relative">
                  <div class="d-flex flex-column flex-md-row p-1 rounded py-2">
                    <div class="col-md-4 col-12 mt-4 form-floating form-group form-select mb-4 pb-0 px-1">
                      <select formControlName="dobMonth" class="form-control text-capitalize border-left-0 border-top-0 border-right-0 ml-1 mt-2" placeholder="Month" (change)="updateDays($event)">
                        <option value="" disabled selected>{{'verifypatient.select_month' | translate}}</option>
                        <option *ngFor="let month of months; let i = index" [value]="i + 1">{{ month }}</option>
                      </select>
                      <label style="font-size:16px;" class="fw-bold">
                        {{'verifypatient.month' | translate}}<span class="text-danger">*</span>
                      </label>
                      <span id="f-zip-err" class="err" *ngIf="loginForm.controls['dobMonth'].touched && loginForm.controls['dobMonth'].invalid">
                        <span class="err ml-2" *ngIf="loginForm.controls['dobMonth'].errors?.required">
                          {{'verifypatient.month_error_msg' | translate}}.
                        </span>
                      </span>
                    </div>

                    <div class="col-md-4 col-12 mt-4 form-floating form-group form-select mb-4 pb-0 px-1">
                      <select formControlName="dobDay" class="form-control text-capitalize border-left-0 border-top-0 border-right-0 ml-1 mt-2">
                        <option value="" disabled selected>{{'verifypatient.select_date' | translate}}</option>
                        <option *ngFor="let day of daysInMonth" [value]="day">{{ day }}</option>
                      </select>
                      <label style="font-size:16px;" class="fw-bold">
                        {{'verifypatient.date_label' | translate}}<span class="text-danger">*</span>
                      </label>
                      <span *ngIf="loginForm.controls['dobDay'].touched && loginForm.controls['dobDay'].invalid">
                        <span class="err ml-2" *ngIf="loginForm.controls['dobDay'].errors?.required">
                          {{'verifypatient.day_error_msg' | translate}}.
                        </span>
                      </span>
                    </div>

                    <div class="col-md-4 col-12 mt-4 form-floating form-group form-select mb-4 pb-0 px-1">
                      <select formControlName="dobyear" class="form-control text-capitalize border-left-0 border-top-0 border-right-0 ml-1 mt-2" (change)="updateDays($event)">
                        <option value="" disabled selected>{{'verifypatient.select_year' | translate}}</option>
                        <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                      </select>
                      <label style="font-size:16px;" class="fw-bold">
                        {{'verifypatient.year' | translate}}<span class="text-danger">*</span>
                      </label>
                      <span id="f-zip-err" class="err" *ngIf="loginForm.controls['dobyear'].touched && loginForm.controls['dobyear'].invalid">
                        <span class="err ml-2" *ngIf="loginForm.controls['dobyear'].errors?.required">
                          {{'verifypatient.year_error_msg' | translate}}.
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
          <!--testing code-->
          <label style="font-size:20px;" class="fw-bold mb-2 ml-1"> {{'verifypatient.dateofbirth'|translate}}</label>
          <div class="col-md-12">
            <div class="form-group">
              <div class="mb-2 border-bottom fw-bold">
                <label style="font-size:20px;">
                  {{'verifypatient.month'|translate}}<span class="text-danger">*</span>
                </label>
                <div class="position-relative border-0 form-select-custom"
                  [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                  <select formControlName="dobMonth" style="font-size:20px !important;"
                    class="form-control text-capitalize border-0" placeholder="Month" (change)="updateDays($event)">
                    <option value="" disabled selected>{{'verifypatient.select_month'|translate}}</option>
                    <option *ngFor="let month of months; let i = index" [value]="i + 1">{{ month }}</option>
                  </select>
                </div>
              </div>
              <div class="mb-2">
                <span id="f-zip-err" class="err"
                  *ngIf="loginForm.controls['dobMonth'].touched && loginForm.controls['dobMonth'].invalid">
                  <span class="err"
                    *ngIf=" loginForm.controls['dobMonth'].errors && loginForm.controls['dobMonth'].errors.required">{{'existingPatientLogin.month_error_msg'|translate}}.</span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <div class="mb-2 border-bottom fw-bold">
                <label style="font-size:20px;">
                  {{'verifypatient.date_label'|translate}}<span class="text-danger">*</span>
                </label>
                <div class="position-relative border-0 form-select-custom"
                  [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                  <select formControlName="dobDay" style="font-size:20px !important;"
                    class="form-control text-capitalize border-0" placeholder="Day">
                    <option value="" disabled selected>{{'verifypatient.select_date'|translate}}</option>
                    <option *ngFor="let day of daysInMonth" [value]="day">{{ day }}</option>
                  </select>
                </div>
              </div>
              <div class="mb-2">
                <span *ngIf="loginForm.controls['dobDay'].touched && loginForm.controls['dobDay'].invalid">
                  <span class="err"
                    *ngIf=" loginForm.controls['dobDay'].errors && loginForm.controls['dobDay'].errors.required">
                    {{'existingPatientLogin.day_error_msg'|translate}}.
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group">
              <div class="mb-2 border-bottom fw-bold">
                <label style="font-size:20px;">
                  {{'verifypatient.year'|translate}}<span class="text-danger">*</span>
                </label>
                <div class="position-relative border-0 form-select-custom "
                  [ngClass]="isDrsite ? 'form-select-blue' : 'form-select'">
                  <select formControlName="dobyear" style="font-size:20px !important;"
                    class="form-control text-capitalize border-0" (change)="updateDays($event)">
                    <option value="" disabled selected>{{'verifypatient.select_year'|translate}}</option>
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                  </select>
                </div>
              </div>
              <div class="mb-2">
                <span id="f-zip-err" class="err"
                  *ngIf="loginForm.controls['dobyear'].touched && loginForm.controls['dobyear'].invalid">
                  <span class="err"
                    *ngIf="loginForm.controls['dobyear'].errors && loginForm.controls['dobyear'].errors.required">
                    {{'existingPatientLogin.year_error_msg'|translate}}.
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-4" *ngIf="flowType =='appointment'">
            <div *ngIf="!isDrsiteCheckoutNotes">
              <div class="form-group border-bottom mb-2 ">

                <label style="font-size:20px;" class="fw-bold">
                  {{'RegistrationPage.email.label'|translate}}<span class="text-danger">*</span>

                </label>
                <div class="position-relative " [ngClass]="isDrsite ? 'codeverifiedEmail_blue' : 'codeverifiedEmail'">

                  <input style="font-size:20px !important;" type="email"
                    placeholder="{{'RegistrationPage.email.placeholder' | translate}}"
                    class="form-control custom-input border-0" formControlName="email"
                    [ngStyle]="{'border' : !isValidEmail ? '1px solid red' : ''}"
                    (input)="validateEmailAddress($event.target)" />
                </div>
              </div>
              <div class="mb-2">
                <span class="err"
                  *ngIf="loginForm.controls['email'].touched && loginForm.controls['email'].hasError('required')">
                  {{ 'RegistrationPage.email.required' | translate }}
                </span>
                <span *ngIf="!isValidEmail" class="err">{{'RegistrationPage.email.error' | translate}}</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4" *ngIf="flowType =='appointment'">
            <div *ngIf="!isDrsiteCheckoutNotes">
              <div class="form-group border-bottom mb-2">
                <label style="font-size:20px;" class="fw-bold">
                  {{'RegistrationPage.cell.label'|translate}}<span class="text-danger">*</span>
                </label>
                <div class="position-relative " [ngClass]="isDrsite ? 'codeverified_blue' : 'codeverified'">
                  <input style="font-size:20px !important;" type="text"
                    placeholder="{{'RegistrationPage.cell.placeholder' | translate}}"
                    class="form-control custom-input border-0" formControlName="cell"
                    (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')"
                    maxlength="14" />
                </div>

              </div>
              <div class="mb-2">
                <span *ngIf="isNotValidPhone" class="err">{{'RegistrationPage.cell.error' | translate}}</span>
                <span
                  *ngIf="loginForm.controls['cell'].invalid && loginForm.controls['cell'].touched && loginForm.controls['cell'].errors!.required"
                  class="err">
                  {{'RegistrationPage.cell.required' | translate}}
                </span>
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- two factor auth modal  -->
  <div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="verifycode">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">SMS Verification</h5>
          <button type="button" (click)="clearTimer()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-2">We've sent an OTP code to your {{linkType}} {{phoneLink}}.<br>Please enter it below:</p>
          <div class="align-items-center d-flex verifycode">
            <div class="form-group mb-0">
              <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config">
              </ng-otp-input>
            </div>
          </div>
          <div *ngIf="!otpEntered" class="err">
            <span style="color: red;">OTP Required.</span>
          </div>
        </div>
        <div class="modal-footer">
          <span class="text-center mr-auto">&nbsp; Resend Code in {{m}}:{{s}}</span>
          <button type="button" [disabled]="remainingTime > 0"
            [ngClass]="remainingTime === 0 ? 'btn btn-outline-primary btn-sm' : 'btn btn-secondary btn-sm'"
            (click)="isSendingOTP ? null : SendOTP()">
            Resend Code
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--(click)="flowType == 'payment' ? LoginPatient() : (isDrsite ? onAddScheduleAppointment() : RegistorPatient())"-->
<footer *ngIf="!IslandeFromQRCode && !isForLabOrder" class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <a class="btn" [ngClass]="isDrsite ? 'blue-btn-outline' : 'btn-outline-primary'" type="button"
        (click)="backPage()">{{'button.back'|translate}}</a>
      <a class="btn " [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'" *ngIf="flowType !=''" type="button"
        (click)="handleNextClick()">{{'button.next'|translate}}</a>
      <!-- <a class="btn " [ngClass]="isDrsite ? 'blue-btn' : 'btn-primary'" *ngIf="flowType !=''" type="button"
        (click)="flowType =='payment' ? LoginPatient() :RegistorPatient()">{{'button.next'|translate}}</a> -->
      <!-- <a class="btn btn-primary" type="button" (click)="RegistorPatient()">{{'button.next'|translate}}</a> -->
      <!-- <a class="btn btn-primary" *ngIf="flowType !=''" type="button"
        (click)="onAddScheduleAppointment()">{{'button.next'|translate}}</a> -->
      <a class="btn btn-primary" *ngIf="flowType ==''" type="button"
        (click)="onSubmit()">{{'button.next'|translate}}</a>
    </div>
  </div>
</footer>

<footer *ngIf="IslandeFromQRCode || isForLabOrder">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6 col-12" style="padding: 0px 30px 0px 30px">
        <button *ngIf="IslandeFromQRCode" class="btn btn-primary w-100" type="button" (click)="onSubmit()">
          {{'verifypatient.get_started'|translate}}
        </button>
        <button *ngIf="!IslandeFromQRCode" class="btn btn-primary w-100" type="button" (click)="handleNextClick()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</footer>




<!--<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_linkexiting">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-body p-4 text-center">
              <h5 class="font-weight-bolder mb-3 text-danger"><strong>Incorrect information, Please try again.</strong></h5>
              <p class="mb-3">In case of any queries, contact your practice
                  <span *ngIf="!practice_phone">office</span>
                  <span *ngIf="practice_phone">at <a href={{phoneLink}} class="text-info">{{practice_phone}}</a></span>.</p>
                  <button type="button" data-toggle="modal" data-dismiss="modal" id="isNotValid_linkexiting" class="btn btn-primary ">OK</button>
          </div>
      </div>
  </div>
</div>-->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_linkexiting">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'verifypatient.Incorrect_information'|translate}}</strong>
        </h5>
        <h6 class="font-weight-bolder mb-3 ">{{'verifypatient.Credentials_do_not_match_our_records'|translate}}</h6>
        <p class="mb-3">
          {{'verifypatient.Please_check'|translate}}
          <span *ngIf="!practice_phone">{{'verifypatient.office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'verifypatient.at'|translate}} <a href={{phoneLink}} [ngClass]="isDrsite ? 'text-info-blue':'text-info'"
              style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>
          {{'verifypatient.if_you_need_assistance'|translate}}
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn"
          [ngClass]="isDrsite ? 'blue-btn' :'btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<!--first name last name modal-->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="enable_Names">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>
            {{
            'existingPatientLogin.moreThanOnePatientExistDob'|
            translate
            }}
          </strong>
        </h5>
        <!--<h6 class="font-weight-bolder mb-3 ">{{'existingPatientLogin.moreThanOnePatientExistbody'|translate}}</h6>-->
        <!--<p class="mb-3">
          {{'verifypatient.Please_check'|translate}}
          <span *ngIf="!practice_phone">{{'verifypatient.office'|translate}}</span>
          <span *ngIf="practice_phone">{{'verifypatient.at'|translate}} <a href={{phoneLink}} class="text-info">{{practice_phone}}</a></span> {{'verifypatient.if_you_need_assistance'|translate}}
        </p>-->
        <button type="button" data-toggle="modal" data-dismiss="modal" id="enable_Names"
          [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<!--first name last name modal-->


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="ismorethenonepatient">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'existingPatientLogin.moreThanOnePatientExistHeading'|translate}}</strong>
        </h5>
        <p class="mb-3">
          {{'existingPatientLogin.moreThanOnePatientExistbody'|translate}}
          <span *ngIf="!practice_phone">{{'existingPatientLogin.existingPatientLogin_office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'existingPatientLogin.existingPatientLogin_at'|translate}} <a href={{phoneLink}} class="text-info"
              style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>.
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="ismorethenonepatient"
          [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="noAppointmentFound">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'existingPatientLogin.noAppointmentheading'|translate}}</strong>
        </h5>
        <p class="mb-3">
          {{'existingPatientLogin.noAppointmentBody'|translate}}
          <span *ngIf="!practice_phone">{{'existingPatientLogin.existingPatientLogin_office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'existingPatientLogin.existingPatientLogin_at'|translate}}<a href={{phoneLink}} class="text-info"
              style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>.
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="noAppointmentFound"
          [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="alreadycheckin">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <!-- It seems like you have already checked-in for your appointment with Wayne, Best at 04:15PM.-->
        <h5 class="font-weight-bolder mb-3 text-danger">
          <strong>{{'existingPatientLogin.already_checkedin_msg'|translate}}</strong>
        </h5>
        <p class="mb-3">
          {{'existingPatientLogin.noAppointmentBody'|translate}}
          <span *ngIf="!practice_phone">{{'existingPatientLogin.existingPatientLogin_office'|translate}}</span>
          <span *ngIf="practice_phone">
            {{'existingPatientLogin.existingPatientLogin_at'|translate}} <a href={{phoneLink}} class="text-info"
              style="direction: ltr; display: inline-block;">{{practice_phone}}</a>
          </span>.
        </p>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="alreadycheckin"
          [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
          {{'button.ok'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade in modal-alert bd-example-modal-sm" id="No_due" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'verifypatient.No_due_balance'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p class="text-center">{{'verifypatient.No_outstanding_balance'|translate}}</p>
        <div class="text-center">
          <button type="button" data-toggle="modal" data-dismiss="modal" id="No_due"
            [ngClass]="isDrsite ? 'blue-btn' :'btn btn-primary' ">
            {{'button.ok'|translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in modal-alert bd-example-modal-sm" id="noLabFoundModal" tabindex="-1" role="dialog"
  data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>Lab/Imaging Order Not Found </strong></h5>
        <p class="mb-3">Your lab/imaging order was not found. Please contact your provider’s office.</p>
        <div class="text-center">
          <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary">
            {{'button.ok'|translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>